import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { globalServices } from "../../../Services/global.service";
import { reportingServices } from "../../../Services/AccountingServices/reporting.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import Tooltip from "../../../Components/Common/Tooltip";
import Select from "react-select";
import { storeStockServices } from "../../../Services/PDFservice/storestock.service";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AuthContext } from "../../../Contexts/AuthContext";
import AsyncSelect from "react-select/async";

import XLSX from "xlsx";
import { roles } from "../../../Config/Roles";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();

  const { userId, roleId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    date: new Date(),
  });

  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    posTag: "",
    storeId: 0,
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  useEffect(() => {
    updateLocName("store-stock");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant),
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenant = result.find((x) => x.id === search.tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }
    //return;
    setIsLoading(true);
    reportingServices
      .getStoreStock({
        storeId: search.storeId,
        from: new Date(),
        to: new Date(),
      })
      .then((res) => {
        console.log("res", res);
        setReports(res.data.data);
        // setPagination({
        //   ...pagination,
        //   totalCount: res.totalCount,
        //   pageIndex: pageI,
        // });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    document.getElementById("actions").style.display = "none";
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "productName",
      text: translator("Naziv proizvoda"),
      headerStyle: () => {
        return { width: "250px", textAlign: "left" };
      },
      style: () => {
        return { width: "250px", textAlign: "left" };
      },
    },
    {
      dataField: "productGroupName",
      text: translator("Grupa"),
    },
    {
      dataField: "taxRateValue",
      text: translator("PDV"),
      headerStyle: () => {
        return { width: "100px", textAlign: "right" };
      },
      style: () => {
        return { width: "100px", textAlign: "right" };
      },
    },
    {
      dataField: "unitOfMeasureName",
      text: translator("Jed. mjere"),
    },
    {
      dataField: "totalQuantityIn",
      text: translator("Kol. ulaz"),
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
    {
      dataField: "totalQuantityOut",
      text: translator("Kol. izlaz"),
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
    {
      dataField: "stockQuantity",
      text: translator("Stanje"),
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
    {
      dataField: "totalPriceIn",
      text: translator("Cijena ulaz"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
    {
      dataField: "totalPriceOut",
      text: translator("Cijena izlaz"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
    {
      dataField: "stockValue",
      text: translator("Vrijednost zalihe"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { textAlign: "right" };
      },
      style: () => {
        return { textAlign: "right" };
      },
    },
  ];

  const exportFunction = () => {
    storeStockServices.handlePrint(reports, reportTag, translator);
  };

  const exportExcelFunction = () => {
    var ws_name = `${translator("StanjeZalihe")}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
      [translator("InvoiceCashBalancePDF-Date"), reportTag.date],
      [
        translator("Naziv proizvoda"),
        translator("Naziv grupe"),
        translator("PDV Stopa"),
        translator("Jedinica mjere"),
        translator("Ulazna količina"),
        translator("Izlazna količna"),
        translator("Stanje"),
        translator("Ulazna cijena"),
        translator("Izlazna cijena"),
        translator("Vrijednost"),
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = reports.map((x) => {
      const array = [
        x.productName,
        x.productGroupName,
        x.taxRateValue,
        x.unitOfMeasureName,
        x.totalQuantityIn,
        x.totalQuantityOut,
        x.stockQuantity,
        x.totalPriceIn,
        x.totalPriceOut,
        x.stockValue,
      ];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [{ width: 20 }, { width: 20 }];
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, ws_name);
  };

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setValue("storeTag", null);
    setValue("posTag", null);
    setTenantObj({
      id: event[0].id,
      label: event[0].label,
      value: event[0].value,
    });
    setSearch({
      ...search,
      tenantId: event[0].id,
    });
    setReportTag({
      ...reportTag,
      tenantName: event[0].label,
    });
    getStores(event[0].id);
    //setReports([]);

    return event[0];
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("StoreStock-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label htmlFor="ddlTenants">
                  {translator("InvIssReport-Filters-Tenants")}
                </label>

                <Controller
                  as={AsyncSelect}
                  control={control}
                  autoComplete="off"
                  name="tenantId"
                  placeholder={translator("Select-Tenant")}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                  onChange={handleOnChangeTenantId}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  value={tenantObj}
                />
                {errors.tenantId && errors.tenantId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                <Tooltip text={translator("StoreTagTooltip-Msg")} />
                <Controller
                  as={Select}
                  control={control}
                  autoComplete="off"
                  name="storeId"
                  placeholder={translator("SelectStoreTag")}
                  rules={{ required: true }}
                  onChange={function (event) {
                    setSearch({
                      ...search,
                      storeId: event[0].value,
                    });
                    setReportTag({
                      ...reportTag,
                      storeName: event[0].label,
                    });

                    return event[0];
                  }}
                  options={
                    storesTag &&
                    storesTag.map((e) => ({
                      id: e.id,
                      label: e.name,
                      value: e.id,
                    }))
                  }
                />
                {errors.storeTag && errors.storeTag.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{""}</label>
                <div className="form-group">
                  <button
                    className="btn btn-primary pull-left mt-2"
                    type="submit"
                  >
                    <span className="icon icon-search"></span>{" "}
                    {translator("InvIssReport-Btn-Search")}
                  </button>
                </div>
              </div>
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <>
              <button
                className="btn btn-outline-secondary "
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
